'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isDebugEnabled = exports.enableDebug = exports.shouldEnableDebugFeatures = undefined;

var _localStorage = require('../utils/services/localStorage/localStorage');

var _localStorage2 = _interopRequireDefault(_localStorage);

var _debugConstants = require('./debugConstants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Services
var shouldEnableDebugFeatures = exports.shouldEnableDebugFeatures = function shouldEnableDebugFeatures() {
    return _localStorage2.default.getItem(_debugConstants.DEBUG_LOCAL_STORAGE_KEY);
};

// Constants


var debugEnabled = false;

var enableDebug = exports.enableDebug = function enableDebug() {
    debugEnabled = true;
};

var isDebugEnabled = exports.isDebugEnabled = function isDebugEnabled() {
    return debugEnabled;
};


//////////////////
// WEBPACK FOOTER
// ./src/client/debug/debugUtil.js
// module id = 299
// module chunks = 0